// extracted by mini-css-extract-plugin
export default {"campaign-container":"Advertise_campaign-container__yv5sX","campaign-text":"Advertise_campaign-text__dMXXO","campaign-image":"Advertise_campaign-image__lWdGi"};